@if (languageService.currentLocation$ | async; as currentLocation) {
  <gpt-location-switcher
    [locations]="environment.locations"
    [selectedLocation]="currentLocation"
    (locationChange)="locationChange($event)"
  />
}
